export const SET_FILE_CREATION = (state, value) => {
  state.addFile.creation = value
}

export const SET_FILE_TYPE = (state, value) => {
  state.addFile.type = value
}

export const SET_FILE_DESCRIPTION = (state, value) => {
  state.addFile.description = value
}

export const SET_FILE_SIZE = (state, value) => {
  state.addFile.size = value
}

export const SET_FILE_FILE = (state, value) => {
  state.addFile.file = value
  if (value) state.addFile.name = value
}

export const ADD_FILE = (state, { key, value }) => {
  state._[key] = value
  state.list.push(key)
}

export const DELETE_FILE = (state, key) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}

export const SET_ISTHEREFILES = (state, value) => {
  state.isThereFiles = value
}

export const SET_TODELETELIST = (state, value) => {
  state.toDeleteList = value
}

export const ADD_TODELETELIST = (state, value) => {
  state.toDeleteList.push(value)
}

export const SET_ID = (state, { key, id }) => {
  state._[key].id = id
}
